<script>
export default {
  components: {},
  data() {
    return {
      submitData: Object.assign({}, this.defaultValue),
      tryingRemove: false,
      tryingStore: false,
    }
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    currentActiveIndex: {
      default: '',
    },
    itemIndex: {
      type: Number,
    },
  },
  computed: {},
  methods: {
    async tryToStore(tag) {
      this.tryingStore = true
      await this.$store.dispatch('mixTag/mixTagStore', { ...this.submitData, type: 'goods' })
      this.$message({
        message: '儲存成功',
        type: 'success',
      })
      this.$emit('refresh')
      this.tryingStore = false
      this.$emit('update', '')
    },
    async tryToRemove() {
      this.tryingRemove = true
      await this.$store.dispatch('mixTag/mixTagRemove', { ids: [this.submitData.id] })
      this.$emit('refresh')
      this.tryingRemove = false
    },
    reset() {
      this.submitData = Object.assign({}, this.defaultValue)
      this.$emit('update', '')
    },
    updateActiveIndex() {
      this.$emit('update', this.itemIndex)
    },
  },
}
</script>

<template>
  <el-form-item>
    <div v-if="itemIndex === currentActiveIndex">
      <div style="text-align: right;">
        <el-button class="is-round" size="mini" type="text" @click="reset">
          <BaseIcon name="trash-alt" class="text-primary" />
          取消
        </el-button>
        <el-button v-loading="tryingStore" class="is-round" type="text" size="mini" @click="tryToStore">
          <BaseIcon name="check" class="text-primary" />
          儲存
        </el-button>
      </div>
      <el-input v-model="submitData.title" style="margin-bottom: 10px;"> </el-input>
    </div>
    <el-input v-else v-model="submitData.title" placeholder="請輸入" :class="$style.editInput" readonly>
      <template v-if="currentActiveIndex === ''">
        <el-button slot="append" type="text" class="isPrimary fs-xl mr-2" size="mini" @click="updateActiveIndex(itemIndex)"><BaseIcon name="edit"/></el-button>
        <el-button slot="append" v-loading="tryingRemove" type="text" class="isPrimary fs-xl ml-2" size="mini" @click="tryToRemove"><BaseIcon name="trash-alt"/></el-button>
      </template>
    </el-input>
  </el-form-item>
</template>

<style lang="scss" module>
.editInput {
  :global {
    .el-input__inner {
      border: transparent;
      background: transparent;
      padding-left: 0;
    }
    .el-input-group__append {
      background: transparent;
      border: 0 !important;
      button.el-button {
        &.isPrimary {
          color: $color-primary;
          &:hover {
            color: $color-primary-light;
          }
        }
      }
    }
  }
}
</style>
